export default __webpack_public_path__ + "static/media/googleIcon.51454057.png";